import { render, staticRenderFns } from "./linchuang.vue?vue&type=template&id=72742a00&"
import script from "./linchuang.vue?vue&type=script&lang=ts&"
export * from "./linchuang.vue?vue&type=script&lang=ts&"
import style0 from "./linchuang.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports